module.exports = __webpack_public_path__ + "img/img-survey-vector.84061d25.png";